import { applyFocusVisible, format, multiply, subtract, toPx, } from "@microsoft/fast-jss-utilities";
import { accentForegroundCut, applyCornerRadius, applyFocusPlaceholderBorder, applyFontWeightNormal, applyScaledTypeRamp, focusOutlineWidth, glyphSize, glyphSizeNumber, highContrastSelector, neutralFillStealthRest, neutralFocus, neutralForegroundRest, neutralOutlineRest, outlineWidth, } from "@microsoft/fast-components-styles-msft";
import { white } from "../utilities/colors";
const primaryBackgroundColor = "#1C8221";
const neutralDarkBackgroundColor = "#595959";
const styles = {
    adLabel: Object.assign({}, applyScaledTypeRamp("t9"), applyFontWeightNormal(), { "line-height": toPx(subtract(glyphSizeNumber, multiply(focusOutlineWidth, 2))), "box-sizing": "border-box", display: "inline-block", "text-align": "center" }, applyFocusPlaceholderBorder(), applyCornerRadius(), { background: primaryBackgroundColor, height: glyphSize, "min-width": "24px", padding: "0 6px", "text-decoration": "none" }, applyFocusVisible({
        "border-color": neutralFocus,
    }), { [highContrastSelector]: {
            display: "inline",
            "border-width": "1px",
        } }),
    adLabel__primary: {
        background: primaryBackgroundColor,
        color: accentForegroundCut(() => primaryBackgroundColor),
    },
    adLabel__neutralDark: {
        background: neutralDarkBackgroundColor,
        color: accentForegroundCut(() => neutralDarkBackgroundColor),
    },
    adLabel__neutralLight: Object.assign({ background: neutralFillStealthRest(() => white), color: neutralForegroundRest(() => white), border: format("{0} solid {1}", toPx(outlineWidth), neutralOutlineRest(() => white)) }, applyFocusVisible({
        "box-shadow": format("0 0 0 {0}, {1} inset", toPx(subtract(focusOutlineWidth, outlineWidth)), neutralFocus),
    })),
};
export default styles;
